<template>
  <div @click="openModal">
    <div>
      <img v-if="!innerText" class="btn" src="/edit_icon.svg" width="24px" />
      <p v-else class="custom_message" v-html="$sanitize(innerText)"></p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'content-field',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      innerText: this.payload.content,
      entityId: this.payload.id
    }
  },
  methods: {
    openModal () {
      this.create({
        designator: 'content-field-modal',
        component_name: 'ContentFieldForm',
        modal_title: 'Alert - missions content editor',
        props: {
          text: this.innerText,
          onSubmit: text => {
            this.$network_utils.updateAlert({ id: this.entityId, content: text }).then(() => {
              this.$utils.emit('show_toast', { text: 'success' })
              this.innerText = text
            })
          }
        }
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
